/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type MobileSuspectedTradeUser_viewer$ref = any;
type SuspectedTradeUser_viewer$ref = any;
export type SuspectedTradeUserLoader_viewer$ref = any;
export type SuspectedTradeUserLoader_viewer = {
    readonly " $fragmentRefs": SuspectedTradeUser_viewer$ref & MobileSuspectedTradeUser_viewer$ref;
    readonly " $refType": SuspectedTradeUserLoader_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SuspectedTradeUserLoader_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "SuspectedTradeUser_viewer",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "MobileSuspectedTradeUser_viewer",
            "args": null
        }
    ]
} as any);
(node as any).hash = '994efb22d2267dbd405643c5fea9f05b';
export default node;
